// Helpers shared by the Live tab components

import { getMatchMomentUTC } from './misc';
import { defaultTimeZone } from './consts';
import { GameTypes, PlayoffRoundNames } from './enums';

export function tournamentTz(tournament) {
  return tournament.timezone || defaultTimeZone;
}

export function gameStartMoment(tournament, game) {
  return getMatchMomentUTC({
    date: game.date,
    time: game.start,
    timezone: tournamentTz(tournament),
  });
}

export function gameEndMoment(tournament, game) {
  return gameStartMoment(tournament, game).add(game.duration || 0, 'minutes');
}

// game.date is 'YYYY-MM-DD' and game.start is 24h 'HH:mm' — plain string
// comparison sorts both correctly
export function sortGamesChrono(games) {
  return [...games].sort((a, b) =>
    a.date === b.date
      ? (a.start || '').localeCompare(b.start || '')
      : (a.date || '').localeCompare(b.date || ''),
  );
}

// First game (chronologically) that hasn't ended yet AND has no score entered.
// A game with a final score counts as played and is skipped, so the "next"
// game (banner + schedule highlight) advances to the next unplayed game.
export function findNextGame(tournament, games, now) {
  return (
    sortGamesChrono(games).find(
      (g) =>
        (g.score1 == null || g.score2 == null) &&
        gameEndMoment(tournament, g).isAfter(now),
    ) || null
  );
}

export function roundName(round) {
  return PlayoffRoundNames[round] || round || '';
}

export function gameTypeLabel(game) {
  if (game.type === GameTypes.PLAYOFF) {
    const name = roundName(game.round);
    return name ? `Playoff — ${name}` : 'Playoff';
  }
  return 'Pool game';
}

export function fieldName(tournament, game) {
  return (
    tournament.fields.find((f) => f.id === game.field)?.name || 'Field TBD'
  );
}

export function matchupLabel(teamsById, game, teamId) {
  const teamName = (id) => teamsById.get(id)?.name || 'TBD';
  if (teamId) {
    const opponent = game.team1 === teamId ? game.team2 : game.team1;
    return `${teamName(teamId)} vs ${teamName(opponent)}`;
  }
  return `${teamName(game.team1)} vs ${teamName(game.team2)}`;
}
